import { ctpFormSchema } from './ctp/CTPFormSchema';
import { pnrFormSchema } from './pnr/PNRFormSchema';
import { ripFormSchema } from './rip/RIPFormSchema';
import { imcsTarFormSchema } from './tar-imcs/IMCSTARFormSchema';
import { trFormSchema } from './tr/TRFormSchema';

/**
 * Maps a deliverable abbreviation (as used by the deliverables table) to the
 * DynamicForm schema that defines its front-end requirements. Lets non-form
 * pages validate a record against the same schema the form page uses before
 * submitting. 'tar' resolves to the active IMCS TAR schema (tar-imcs route).
 */
export const formSchemaByAbbreviation = {
  tar: imcsTarFormSchema,
  ctp: ctpFormSchema,
  pnr: pnrFormSchema,
  rip: ripFormSchema,
  tr: trFormSchema,
};

/**
 * Maps a deliverable abbreviation to the REST collection segment used to fetch
 * the underlying form record (e.g. GET /api/{route}/{id}). Trip Reports use a
 * different segment than their abbreviation.
 */
export const formRouteByAbbreviation = {
  tar: 'tars',
  ctp: 'ctps',
  pnr: 'pnrs',
  rip: 'rips',
  tr: 'trip-reports',
};

/**
 * Maps a deliverable abbreviation to its front-end VIEW route segment (the page
 * the browser opens for `/{segment}/{id}?mode=view`). Most equal the abbreviation;
 * TAR's active form lives at /tar-imcs — the /tar route is the retired legacy form.
 * Consumers that navigate by abbreviation should resolve through this map so a
 * record opens the current form rather than the abbreviation-named route.
 */
export const formViewRouteByAbbreviation = {
  tar: 'tar-imcs',
  ctp: 'ctp',
  pnr: 'pnr',
  rip: 'rip',
  tr: 'tr',
};
